import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import LoginSimplificado from './components/LoginSimplificado'
import EsqueciSenha from './components/EsqueciSenha'
import RedefinirSenhaPublica from './components/RedefinirSenhaPublica'
import AlterarSenha from './components/AlterarSenha'
import Welcome from './components/Welcome'
import './App.css'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginSimplificado />} />
          <Route path="/esqueci-senha" element={<EsqueciSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenhaPublica />} />
          <Route path="/alterar-senha" element={<AlterarSenha />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
